
import { pipelineResult } from './pipelineResult.js'

let pipelineContext = (objectInstance) => {
    return {
        objectInstance
    }
}

let runPipeline = (pipeline, context) => {
    let ruleResults = []

    if (pipeline && context) {
        pipeline.rules.forEach(r => {
            let result = r(context)
            if (result)
                ruleResults.push(result)
        })
        return pipelineResult(pipeline.id, pipeline.name, context, ruleResults)
    }

    return null
}

export { pipelineContext, runPipeline }